export default __webpack_public_path__ + "static/building_pin-unselected.9a44e3b59724fcdc52b1f8bf790efaea.png";